module.exports = __webpack_public_path__ + "static/media/primera_imagen.b081a177.png";